import AsyncAlpine from 'async-alpine';
import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import persist from '@alpinejs/persist';
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";

/* 1st party magic */
import './_magic/smoothscroll.js';

/* 1st party components */
import { app } from "./app.js";
import html5Video from "./html5Video/index.js";
import { iframeVideo } from "./iframeVideo.js";
import { floorplan } from "./floorplan.js";
import notification from "./notification.js";
import client from './shopify/client.js';
import lineItem from './shopify/lineItem.js';
import countryPrice from "./shopify/countryPrice.js";
import product from './shopify/product.js';

/* plugins */
Alpine.plugin(AsyncAlpine);
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(persist);

/* data components */
Alpine.data("app", app);
Alpine.data("html5Video", html5Video);
Alpine.data("iframeVideo", iframeVideo);
Alpine.data("floorplan", floorplan);

Alpine.data("notification", notification);
Alpine.data("product", product);
Alpine.data("lineItem", lineItem);
Alpine.data("countryPrice", countryPrice);

/* async data components */
Alpine.asyncData('slideshow', () => import('./slideshow.js'));

/* stores */
Alpine.store('prefersReducedMotion', window.matchMedia('(prefers-reduced-motion: reduce)').matches);
Alpine.store('cart', client(
  window.SHOPIFY_HOSTNAME,
  window.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  window.SHOPIFY_BUYER_CURRENCY
));

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
